import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
} from '@mui/material';
import {
  Facebook,
  Twitter,
  LinkedIn,
  Phone,
  Email,
  LocationOn,
} from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Contact Information */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Contactez-nous
            </Typography>
            <Box sx={{ mt: 2 }}>
              {/* France Office */}
              <Typography variant="subtitle1" gutterBottom>
                Bureau en France
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <LocationOn sx={{ mr: 1 }} />
                <Typography variant="body2">
                  7 AVENUE LOUIS BLERIOT, 93120 LA COURNEUVE
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Phone sx={{ mr: 1 }} />
                <Typography variant="body2">
                  <Link href="tel:+33652983519" color="inherit">
                    +33 6 52 98 35 19
                  </Link>
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Email sx={{ mr: 1 }} />
                <Typography variant="body2">
                  <Link href="mailto:contact@aft-import-export.net" color="inherit">
                    contact@aft-import-export.net
                  </Link>
                </Typography>
              </Box>

              {/* Ivory Coast Offices */}
              <Typography variant="subtitle1" gutterBottom sx={{ mt: 2 }}>
                Bureaux en Côte d'Ivoire
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <LocationOn sx={{ mr: 1 }} />
                <Typography variant="body2">
                  Angré & Cocody, Abidjan
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Phone sx={{ mr: 1 }} />
                <Link href="tel:+225XXXXXXXXX" color="inherit">
                  +225 XX XX XX XX XX
                </Link>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <Email sx={{ mr: 1 }} />
                <Link href="mailto:contact@aft-import-export.net" color="inherit">
                  contact@aft-import-export.net
                </Link>
              </Box>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Liens Rapides
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2 }}>
              <Link component={RouterLink} to="/services" color="inherit">
                Nos Services
              </Link>
              <Link component={RouterLink} to="/quote" color="inherit">
                Demander un Devis
              </Link>
              <Link component={RouterLink} to="/tracking" color="inherit">
                Suivi de Colis
              </Link>
              <Link component={RouterLink} to="/schedule" color="inherit">
                Calendrier des Départs
              </Link>
              <Link component={RouterLink} to="/appointment" color="inherit">
                Prendre Rendez-vous
              </Link>
              <Link component={RouterLink} to="/contact" color="inherit">
                Contact
              </Link>
            </Box>
          </Grid>

          {/* Social Media and Hours */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Suivez-nous
            </Typography>
            <Box sx={{ mt: 2 }}>
              <IconButton color="inherit" aria-label="Facebook">
                <Facebook />
              </IconButton>
              <IconButton color="inherit" aria-label="Twitter">
                <Twitter />
              </IconButton>
              <IconButton color="inherit" aria-label="LinkedIn">
                <LinkedIn />
              </IconButton>
            </Box>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
              Horaires d'Ouverture
            </Typography>
            <Typography variant="body2">
              Lundi - Vendredi: 9h00 - 18h00
            </Typography>
            <Typography variant="body2">
              Samedi: 9h00 - 13h00
            </Typography>
            <Typography variant="body2">
              Dimanche: Fermé
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ mt: 4, mb: 4, bgcolor: 'rgba(255, 255, 255, 0.2)' }} />

        <Typography variant="body2" align="center">
          &copy; {currentYear} AFT IMPORT EXPORT. Tous droits réservés.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
